export default __webpack_public_path__ + "static/char-v-37-a962cde17dcab7139db46cd0bddee44a.png";